import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Tables } from "@/integrations/supabase/types";

type Lead = Tables<"leads">;

export const ContactInformation = ({ lead }: { lead: Lead }) => (
  <Card className="mb-6">
    <CardHeader>
      <CardTitle>Contact Information</CardTitle>
    </CardHeader>
    <CardContent className="space-y-2">
      <div>
        <div className="font-medium">Name</div>
        <div>{lead.name}</div>
      </div>
      <div>
        <div className="font-medium">Email</div>
        <div>{lead.email}</div>
      </div>
      <div>
        <div className="font-medium">Phone</div>
        <div>{lead.phone || "Not provided"}</div>
      </div>
      <div>
        <div className="font-medium">Preferred Contact Method</div>
        <div className="capitalize">
          {lead.preferred_contact_method?.replace(/_/g, " ") || "Not specified"}
        </div>
      </div>
      <div>
        <div className="font-medium">Preferred Contact Time</div>
        <div>{lead.preferred_contact_time || "Not specified"}</div>
      </div>
    </CardContent>
  </Card>
);